import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { persistentFlagsSelector } from 'common/selectors/flagsSelector';
import { addQueryToUrl } from 'lib/format';

const AnchorWithFlags = (props) => {
    const { ownProps, flags, href } = props;
    if (!href) {
        return <span {...ownProps} />;
    }
    const newProps = {
        ...ownProps,
        href: addQueryToUrl(href, flags)
    };
    return <a {...newProps} />;
};

AnchorWithFlags.propTypes = {
    href: PropTypes.string,
    ownProps: PropTypes.object,
    flags: PropTypes.object
};

const mapStateToProps = (state, ownProps) => ({
    ownProps,
    flags: persistentFlagsSelector(state)
});

export default connect(mapStateToProps)(AnchorWithFlags);



// WEBPACK FOOTER //
// ./app/common/AnchorWithFlags.js